export default __webpack_public_path__ + "static/media/economics.495f13b1.webp";